import { render, staticRenderFns } from "./CreateCollectionDrawer.vue?vue&type=template&id=93362bc6&scoped=true"
import script from "./CreateCollectionDrawer.vue?vue&type=script&lang=js"
export * from "./CreateCollectionDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreateCollectionDrawer.vue?vue&type=style&index=0&id=93362bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93362bc6",
  null
  
)

export default component.exports